import { AxiosError } from "axios";
import { ChatBusinessCategoriesResponse } from "src/entities/v3/ChatBusinessCategoriesResponse";
import { usePost } from "./usePost";

interface Callbacks {
  onSuccess?: (data: ChatBusinessCategoriesResponse) => void;
  onError?: (err: AxiosError) => void;
  onStart?: () => void;
  onEnd?: () => void;
}

export const useChatBusinessCategories = () => {
  const { post, isLoading } = usePost<ChatBusinessCategoriesResponse>({
    url: `${process.env.REACT_APP_DOMAIN_V3}/api/v3/articles/chat/business-categories`,
  });

  // article: チャットレスポンスの article オブジェクト。JSON 文字列化して送る。
  const fetchCategories = (article: object, callbacks?: Callbacks) =>
    post({
      params: { article: JSON.stringify(article) },
      onSuccess: callbacks?.onSuccess
        ? (data?: unknown) =>
            callbacks.onSuccess?.(data as ChatBusinessCategoriesResponse)
        : undefined,
      onError: callbacks?.onError,
      onStart: callbacks?.onStart,
      onEnd: callbacks?.onEnd,
    });

  return { fetchCategories, isLoading };
};
